// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.option-container {
  background-color: rgb(255, 255, 255) !important;
  border-radius: 25px !important;
  margin-bottom: 30px !important;
  width: 96% !important;
  list-style-type: none;
}
.option-container h2 {
  text-align: left;
  font-weight: 900;
  font-size: 20/30px;
  font-family: "Lato", sans-serif !important;
  letter-spacing: 0px;
  color: #151515;
  opacity: 1;
}
.option-container h4 {
  margin-top: 10px;
}
.option-container .accordion-divider {
  width: 100%;
}
.option-container .accordion-divider .dropdown-item {
  width: 100%;
}
.option-container .option-icon {
  margin-inline: 0.5em;
  margin-block: 0.5em;
  font-size: 2em;
}

.option-item {
  padding: 20px;
  border-top: 25px;
  margin-bottom: 25px;
}

.no-border-container {
  padding: 0px !important;
  margin: 0px !important;
}

.option-item-border {
  border-bottom: 1px solid #cccccc;
  padding: 30px;
}

.description {
  font-family: "Lato", sans-serif !important;
  font-size: 16px;
}

.text {
  display: flex;
  flex: 1 1;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  align-content: flex-start;
  height: auto;
  background-color: rgb(255, 255, 255);
}

.image-content {
  max-height: 350px;
}

.seeArticle {
  font-size: 20px;
  color: rgb(18, 101, 183);
  font-family: "Lato", sans-serif !important;
}

.image-preview {
  align-self: center;
  background-color: rgb(255, 255, 255);
}

.pagination-options {
  background-color: rgb(255, 255, 255) !important;
  display: flex !important;
  align-items: flex-end !important;
  align-content: flex-end !important;
  justify-content: flex-end !important;
  align-self: flex-end !important;
  padding-right: 20px;
  margin-top: 1rem;
}

.accordion-divider {
  list-style-type: none;
}

@media (max-width: 575px) {
  .option-item-border {
    margin-top: 1rem !important;
  }
}

`, "",{"version":3,"sources":["webpack://./src/sass/layout/optionListContainer/optionListContainer.scss","webpack://./src/sass/layout/optionListContainer/optionListContainer.css","webpack://./src/sass/utilities/_variables.scss"],"names":[],"mappings":"AAIA;EACE,+CAAA;EACA,8BAAA;EACA,8BAAA;EACA,qBAAA;EAcA,qBAAA;AChBF;ADGE;EACE,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,0CEXG;EFYH,mBAAA;EACA,cAAA;EACA,UAAA;ACDJ;ADGE;EACE,gBAAA;ACDJ;ADKE;EACE,WAAA;ACHJ;ADII;EACE,WAAA;ACFN;ADME;EACE,oBAAA;EACA,mBAAA;EACA,cAAA;ACJJ;;ADQA;EACE,aAAA;EACA,gBAAA;EACA,mBAAA;ACLF;;ADQA;EACE,uBAAA;EACA,sBAAA;ACLF;;ADQA;EACE,gCAAA;EACA,aAAA;ACLF;;ADQA;EACE,0CEpDK;EFqDL,eAAA;ACLF;;ADQA;EACE,aAAA;EACA,SAAA;EACA,sBAAA;EACA,8BAAA;EACA,uBAAA;EACA,yBAAA;EACA,YAAA;EACA,oCEzDM;ADoDR;;ADQA;EACE,iBAAA;ACLF;;ADQA;EACE,eAAA;EACA,wBE7DU;EF8DV,0CE1EK;ADqEP;;ADQA;EACE,kBAAA;EACA,oCExEM;ADmER;;ADQA;EACE,+CAAA;EACA,wBAAA;EACA,gCAAA;EACA,kCAAA;EACA,oCAAA;EACA,+BAAA;EACA,mBAAA;EACA,gBAAA;ACLF;;ADQA;EACE,qBAAA;ACLF;;ADUA;EACE;IACE,2BAAA;ECPF;AACF","sourcesContent":["@import \"../../utilities/mixins\";\n@import \"../../utilities/variables\";\n \n\n.option-container {\n  background-color: $White !important;\n  border-radius: 25px !important;\n  margin-bottom: 30px !important;\n  width: 96% !important;\n  h2 {\n    text-align: left;\n    font-weight: 900;\n    font-size: 20/30px;\n    font-family: $Font;\n    letter-spacing: 0px;\n    color: #151515;\n    opacity: 1;\n  }\n  h4 {\n    margin-top: 10px;\n  }\n\n  list-style-type: none;\n  .accordion-divider {\n    width: 100%;\n    .dropdown-item {\n      width: 100%;\n    }\n  }\n\n  .option-icon {\n    margin-inline: 0.5em;\n    margin-block: 0.5em;\n    font-size: 2em;\n  }\n}\n\n.option-item {\n  padding: 20px;\n  border-top: 25px;\n  margin-bottom: 25px;\n}\n\n.no-border-container {\n  padding: 0px !important;\n  margin: 0px !important;\n}\n\n.option-item-border {\n  border-bottom: 1px solid #cccccc;\n  padding: 30px;\n}\n\n.description {\n  font-family: $Font;\n  font-size: 16px;\n}\n\n.text {\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: flex-start;\n  align-content: flex-start;\n  height: auto;\n  background-color: $White;\n}\n\n.image-content {\n  max-height: 350px;\n}\n\n.seeArticle {\n  font-size: 20px;\n  color: $LinkColor;\n  font-family: $Font;\n}\n\n.image-preview {\n  align-self: center;\n  background-color: $White;\n}\n\n.pagination-options {\n  background-color: $White !important;\n  display: flex !important;\n  align-items: flex-end !important;\n  align-content: flex-end !important;\n  justify-content: flex-end !important;\n  align-self: flex-end !important;\n  padding-right: 20px;\n  margin-top: 1rem;\n}\n\n.accordion-divider {\n  list-style-type: none;\n}\n\n\n\n@media (max-width: 575px) {\n  .option-item-border {\n    margin-top: 1rem !important;\n  }\n}",".option-container {\n  background-color: rgb(255, 255, 255) !important;\n  border-radius: 25px !important;\n  margin-bottom: 30px !important;\n  width: 96% !important;\n  list-style-type: none;\n}\n.option-container h2 {\n  text-align: left;\n  font-weight: 900;\n  font-size: 20/30px;\n  font-family: \"Lato\", sans-serif !important;\n  letter-spacing: 0px;\n  color: #151515;\n  opacity: 1;\n}\n.option-container h4 {\n  margin-top: 10px;\n}\n.option-container .accordion-divider {\n  width: 100%;\n}\n.option-container .accordion-divider .dropdown-item {\n  width: 100%;\n}\n.option-container .option-icon {\n  margin-inline: 0.5em;\n  margin-block: 0.5em;\n  font-size: 2em;\n}\n\n.option-item {\n  padding: 20px;\n  border-top: 25px;\n  margin-bottom: 25px;\n}\n\n.no-border-container {\n  padding: 0px !important;\n  margin: 0px !important;\n}\n\n.option-item-border {\n  border-bottom: 1px solid #cccccc;\n  padding: 30px;\n}\n\n.description {\n  font-family: \"Lato\", sans-serif !important;\n  font-size: 16px;\n}\n\n.text {\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: flex-start;\n  align-content: flex-start;\n  height: auto;\n  background-color: rgb(255, 255, 255);\n}\n\n.image-content {\n  max-height: 350px;\n}\n\n.seeArticle {\n  font-size: 20px;\n  color: rgb(18, 101, 183);\n  font-family: \"Lato\", sans-serif !important;\n}\n\n.image-preview {\n  align-self: center;\n  background-color: rgb(255, 255, 255);\n}\n\n.pagination-options {\n  background-color: rgb(255, 255, 255) !important;\n  display: flex !important;\n  align-items: flex-end !important;\n  align-content: flex-end !important;\n  justify-content: flex-end !important;\n  align-self: flex-end !important;\n  padding-right: 20px;\n  margin-top: 1rem;\n}\n\n.accordion-divider {\n  list-style-type: none;\n}\n\n@media (max-width: 575px) {\n  .option-item-border {\n    margin-top: 1rem !important;\n  }\n}\n\n","// Utils\n$DecorationNone: none;\n$Font: \"Lato\", sans-serif !important;\n$Font-size-navbar: 12px;\n$LetterSpacing: 0px;\n\n// Colors\n$Transparent: rgba(0, 0, 0, 0);\n$RedColor: rgb(143, 0, 60, 1);\n$White: rgba(255, 255, 255, 1);\n$Black: rgba(26, 25, 25, 1);\n$MainBackgroundColor: rgba(247, 248, 249, 1);\n$SecondaryBackgroundColor: rgba(221, 208, 208, 0.5);\n$GrayColor: rgba(204, 204, 204, 1);\n$LinkColor: rgba(18, 101, 183, 1);\n$LinkSecondColor: rgba(78, 125, 162, 1);\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
